var constants = {
  Private: { id: 1, description: "Private" },
  Shared: { id: 2, description: "Shared with partners" },
};
export default {
  constants,
  getById: id => Object.values(constants).find(x => x.id === id),
};
